import React from "react"
import { Pressable, Text, View, DeviceEventEmitter } from "react-native";

import { debounce } from "lodash";
import { store } from "../../store/store";
import { View as AnimatableView, } from "react-native-animatable";

import { reformatLocationString } from "../../utils/services/ReformatUtils";
import { getCartTotalItemCount } from "../../utils/services/oms/UpsertCartData";
import { checkIsAddressCompleted } from "../../utils/services/user/UserAddressUtils";
import { getCartItemFroRedux, getCartImagesFromRedux, calculateCartAmount, getOrderSavingsAmount } from "../../utils/services/oms/OMSCartUtils";

import { IconView } from "../../utils/widgets/CommonWidget/Icons";
import { CommonTooltipHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import { EstimatedPriceView } from "../../utils/widgets/cart/EstimatedPriceBottomSheet";

import { IndiaRupee } from "../../utils/constants/AppConstants";
import { ActionFromParent } from "../../utils/constants/ConstantsMapping";

import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";
import AppStyles from "../../AppStyles";

import CartViewComponent from '../tab-component/CartViewComponent';

export default class ReviewOrder extends React.Component<any, any> {
    constructor(props) {
        const reduxState: any = store.getState();
        super(props); this.state = {
            isUserLoggedIn: reduxState.isUserLogin,

            cartProducts: [],
            prescriptionData: [],

            cartItemCount: 0,
            cartTotalAmount: 0,

            selectedLocation: {},
        }
    }


    componentDidMount() {
        this.cartDataSubscription()
        store.subscribe(() => {
            this.cartDataSubscription()
        })
    }

    cartDataSubscription = debounce(this.updateCartData, AppTheme.debouceTimeout)

    updateCartData() {
        let cartItems = getCartItemFroRedux()
        let cartImageList = getCartImagesFromRedux()
        let cartItemCount = getCartTotalItemCount()
        let cartTotalAmount = calculateCartAmount(cartItems)
        this.setState({
            cartProducts: cartItems,
            prescriptionData: cartImageList,
            cartItemCount: cartItemCount,
            cartTotalAmount: cartTotalAmount,
        });
    }

    setSelectedLocation(location) {
        this.setState({ selectedLocation: location })
    }

    getBottomCTATitle() {
        if (checkIsAddressCompleted(this.state.selectedLocation))
            return 'Place Order'
        else return 'Select Address'
    }

    bottomCTAFunction() {
        let action = ''
        if (this.state.isUserLoggedIn) {
            if (checkIsAddressCompleted(this.state.selectedLocation))
                action = ActionFromParent.placeOrder
            else action = ActionFromParent.selectLocationInCart
        } else action = ActionFromParent.addNewAddress
        DeviceEventEmitter.emit('actionFromParent', { action: action });
    }

    disableOrderCTA() {
        if ((this.state.cartProducts && this.state.cartProducts?.length) ||
            (this.state.prescriptionData && this.state.prescriptionData?.length))
            return false;
        else return true;
    }

    getCartBottomPadding() {
        let padding = 0
        if (getOrderSavingsAmount(this.state?.cartProducts) > 0)
            padding += AppTheme.totalSavingHeight
        if (getCartTotalItemCount() > 0)
            padding += AppTheme.estimatedPriceBarHeight
        return padding
    }

    render() {
        return <View>

            <CommonTooltipHeader title='My Cart'
                showBackIcon={true}
                navigation={this.props.navigation}
                selectedLocation={this.state.selectedLocation}
                toolTipView={() => this.SelectedLocationView()}
                toolTipContainerView={() => this.SelectedLocationInfo()}
                locationIconView={() => this.ChangeLocationIconView()} />

            <AnimatableView key={'cart tab'} animation="fadeInLeft"
                duration={AppTheme.tabTransitionDuration}
                style={[AppStyles.screenViewWithHeader, { paddingBottom: this.getCartBottomPadding() }]}>
                <CartViewComponent getBottomPadding={() => this.getCartBottomPadding()}
                    navigation={this.props.navigation} route={this.props.route}
                    setSelectedLocation={(location) =>
                        this.setSelectedLocation(location)} /></AnimatableView>

            {this.state.cartItemCount ? <View>
                {getOrderSavingsAmount(this.state?.cartProducts) > 0 ?
                    <View style={[AppStyles.bottomFix, AppStyles.py6, AppStyles.alignCenter, {
                        marginBottom: AppTheme.estimatedPriceBarHeight,
                        backgroundColor: AppTheme.color.green.primary
                    }]}><Text style={[TextStyle.text12, TextStyle.colorWhite, TextStyle.alignCenter]}>
                            Your total savings on this order is <Text style={TextStyle.text12b}>
                                {IndiaRupee}{getOrderSavingsAmount(this.state.cartProducts)}</Text></Text>
                    </View> : null}
                <EstimatedPriceView
                    ctaTitle={this.getBottomCTATitle()}
                    ctaAction={() => this.bottomCTAFunction()}
                    isCtaDisabled={this.disableOrderCTA()}
                    cartTotalAmount={this.state.cartTotalAmount} />

            </View> : null}

        </View>
    }

    SelectedLocationView() {
        return <View style={[AppStyles.flexRowEnd]}>
            <IconView width={13} height={19} icon={'location/blue.svg'} />
            <Text ellipsizeMode="tail" numberOfLines={1} style={[TextStyle.text16b,
            { marginHorizontal: 6, maxWidth: AppTheme.appWidth * 0.35 }]}>
                {this.state.selectedLocation?.name}</Text>
        </View>
    }

    SelectedLocationInfo() {
        let location = this.state.selectedLocation
        return <Text style={[TextStyle.text12, TextStyle.flexWrap,
        TextStyle.colorWhite, { maxWidth: AppTheme.appWidth / 2 }]}>
            {location.name}, {reformatLocationString(
                location['flat_and_building'],
                location['locality'])}</Text>
    }

    ChangeLocationIconView() {
        return <Pressable onPress={() => {
            DeviceEventEmitter.emit('actionFromParent',
                { action: ActionFromParent.showLocationBottoSheet })
        }}><IconView size={20} icon={'edit_circle.svg'} /></Pressable>
    }

}
